export class ArrayUtils {
  static isEmpty = <T>(array: T[]) =>
    Array.isArray(array) && array.length === 0;

  /**
   * Returns updated list where entries that match element.id are replaced by element.
   * @param li List to be sorted and updated
   * @param element Element that will be searched for by id and that replaces all matches.
   */
  static updateListById<T extends { id?: string | number }>(
    li: T[],
    element: T
  ): T[] {
    return li.map(item => (item.id === element.id ? element : item));
  }

  /**
   * Returns new list with entries matching element.id removed.
   * @param li List from which element will be removed.
   * @param element Element to remove.
   */
  static deleteFromListById<T extends { id?: string | number }>(
    li: T[],
    element: T
  ): T[] {
    return li.filter(x => x.id !== element.id);
  }
}
